module.exports = __webpack_public_path__ + "officialStatic/img/case39.c126e33.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/partner/case39.jpg
// module id = r8Mc
// module chunks = 0